import { createAsyncThunk } from "@reduxjs/toolkit";

import { type TraineeSettings } from "@fitness-app/data-models/entities/TraineeSettings";

import { type AsyncThunkCreator } from "../../../index";
import { TRAINEE_REDUCER_NAME } from "../types";

type Payload = {
  onboarding: TraineeSettings["onboarding"];
  id: string;
};

export const updateTraineeOnboardingSettings = createAsyncThunk<TraineeSettings, Payload, AsyncThunkCreator<string>>(
  `${TRAINEE_REDUCER_NAME}/updateTraineeOnboardingSettings`,
  async (payload, { rejectWithValue, extra: { db, analytics } }) => {
    const { data, error } = await db
      .from("trainee_settings")
      .update({ onboarding: payload.onboarding, updatedAt: new Date().toISOString() })
      .eq("id", payload.id)
      .select("*")
      .single<TraineeSettings>();

    if (error || !data) {
      return rejectWithValue(error?.message || "Failed to update notifications settings");
    }

    analytics.track("update_trainee_onboarding_settings");

    return data;
  },
);
